import Nav from "./Nav";
import Project from "./Project";
import imgOne from "../images/prod.png"
import domino from "../images/domino.png"
import tipapp from "../images/tipapp.webp"
import notes from "../images/notes.png"
import countrie from "../images/countrie.webp"
import burg from "../images/burg.png"
import netflix from "../images/netflix.png"
import tracking from "../images/time-tracking.webp"
import datapic from "../images/datapic.jpg"
import cabo from "../images/cabo.jpg"
import nador from "../images/nador.jpg"
import medical from "../images/medical.jpg"
import project_management from "../images/project-management.jpg"
import emploi from "../images/emploi.jpg"
import ticket from "../images/ticket.png"
import dawajin from "../images/dawajin.png"
import absnotes from "../images/absnotes.png"
export default function Portfolio() {
    return (
        <>

            <Nav />
            <section className="portfolio">
                <h1>Mes Projets</h1>
                <p className="descWorks">Voici quelques-uns des <span>projets front-end sur lesquels j'ai travaillé</span> dans différents <span>langages de programmation.</span></p>
                <div className="projectPortfolio">
                    {/* <h3 style={{color:"white"}}>This page is under maintenance.</h3> */}
                    <Project img={dawajin} title="Gestion des ventes de volailles" git="#" linke="https://dawajin.laghmam.com/" />
                    <Project img={ticket} title="gestion des réclamations" git="#" linke="https://gs-tickets.laghmam.com/administration/dashboard" />
                    <Project img={cabo} title="Réservation de maison" git="#" linke="https://lacasitadelcabo.es/" />
                    <Project img={datapic} title="Gestion des services" git="#" linke="https://datapic.ma/fr/" />
                    <Project img={nador} title="Gestion des ressources humaines" git="#" linke="https://rhdpnador.ma/" />
                    <Project img={medical} title="anmedexpress" git="#" linke="https://anmedexpress.com/" />
                    <Project img={project_management} title="Gestion et suivi de projet" git="#" linke="https://project-management.laghmam.com/login" />
                    <Project img={emploi} title="Gestion des emplois du temps" git="#" linke="https://emploi-temp.laghmam.com/login" />
                    <Project img={absnotes} title="Gestion des notes et absences" git="#" linke="https://gestion-notes-bsences.laghmam.com/" />
                    <Project img={imgOne} title={"Magasin de produits"} linke={"https://fake-product-sotre.netlify.app/"} git={"https://github.com/BILAL-LAGHMAM/products-management"} />
                    <Project img={domino} title="Jeu de dominos" git="https://github.com/BILAL-LAGHMAM/domino" linke="https://dominogame22.netlify.app/" />
                    {/* <Project img={tipapp} title="Tipe Calculator App" git="https://github.com/BILAL-LAGHMAM/tipe-calculator" linke="https://tip-calculator-app23.netlify.app/" /> */}
                    <Project img={notes} title="Gestion des notes" git="https://github.com/BILAL-LAGHMAM/TodoApp" linke="https://notes-management23.netlify.app/" />
                    <Project img={countrie} title="API des pays" git="https://github.com/BILAL-LAGHMAM/countries-api-app" linke="https://api-countries-app23.netlify.app/" />
                    {/* <Project img={burg} title="food drink menu" git="https://github.com/BILAL-LAGHMAM/menu-food-and-drink" linke="https://food-drink-menu.netlify.app/" /> */}
                    {/* <Project img={netflix} title="Netflix landing page" git="https://github.com/BILAL-LAGHMAM/netflix" linke="https://netflix-landing23.netlify.app/" /> */}
                    {/* <Project img={tracking} title="Time Tracking Dashboard Main" git="https://github.com/BILAL-LAGHMAM/time-tracking-dashboard-main" linke="https://time-tracking-dashboard-main22.netlify.app/" /> */}

                </div>
            </section>

        </>
    );
}